import { Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import React from 'react';

interface CellEmailTemplateActionsProps {
  params: any;
  onClick: (params: any, clickedElement: 'edit' | 'download' | 'expire') => void;
  children?: React.ReactNode;
}

const CellEmailTemplateActions = ({
  params,
  onClick,
}: CellEmailTemplateActionsProps) => {
  const isActive = String(params?.row?.status ?? '').toUpperCase() === 'ACTIVE';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Tooltip title={isActive ? 'Edit' : 'Edit (available when status is Active)'}>
        <span>
          <IconButton
            size="small"
            aria-label="edit"
            disabled={!isActive}
            onClick={(e) => {
              e.stopPropagation();
              if (isActive) onClick(params, 'edit');
            }}
            sx={{ padding: 0.5 }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Download">
        <IconButton
          size="small"
          aria-label="download"
          onClick={(e) => {
            e.stopPropagation();
            onClick(params, 'download');
          }}
          sx={{ padding: 0.5 }}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title={isActive ? 'Expire' : 'Expire (available when status is Active)'}>
        <span>
          <IconButton
            size="small"
            aria-label="expire"
            disabled={!isActive}
            onClick={(e) => {
              e.stopPropagation();
              if (isActive) onClick(params, 'expire');
            }}
            sx={{ padding: 0.5 }}
          >
            <EventBusyIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default CellEmailTemplateActions;
